import React, {useContext} from "react"

export const OrgPermissionContext = React.createContext(null);

export default function usePermissions() {
  const [orgPermissions] = useContext(OrgPermissionContext);

  return orgPermissions;
}